/**
 * Limita las lecturas simultáneas contra la API.
 *
 * El navegador solo mantiene ~6 conexiones por host y la cartelera lanza dos GET por
 * tarjeta (película + sesiones): con la API lenta esas peticiones ocupan todos los
 * slots y el resto de la web (datos del cine, imágenes) se queda esperando detrás.
 * Dejando un par de slots libres, lo demás sigue cargando.
 */

const MAX_CONCURRENT = 4;

// Red de seguridad: si una tarea no libera su slot, lo liberamos igualmente para que
// la cola no se quede bloqueada para siempre. Muy por encima del timeout de lectura.
const SLOT_RELEASE_TIMEOUT_MS = 30000;

let running = 0;
const pending = [];

const runNext = () => {
  if (running >= MAX_CONCURRENT || pending.length === 0) {
    return;
  }
  const task = pending.shift();
  running += 1;

  let released = false;
  const release = () => {
    if (released) {
      return;
    }
    released = true;
    clearTimeout(safetyTimer);
    running -= 1;
    runNext();
  };
  const safetyTimer = setTimeout(release, SLOT_RELEASE_TIMEOUT_MS);

  try {
    task(release);
  } catch (error) {
    // No propagamos: una tarea rota libera su slot y no tumba a quien la encoló.
    console.warn('[requestQueue] Tarea fallida', error);
    release();
  }
};

/**
 * Encola una petición. `task` recibe un callback que debe invocar al terminar, en
 * éxito o en error, para liberar el slot.
 */
export const enqueueRequest = (task) => {
  pending.push(task);
  runNext();
};
